import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_ENDPOINTS } from "../config/api";
import "../styles/Idols.css";

const API = API_ENDPOINTS.IDOL;

const Idols = () => {
  const [idols, setIdols] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  /* ================= FETCH IDOLS ================= */

  const fetchIdols = async () => {
    try {
      const res = await axios.get(API);
      setIdols(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchIdols();
  }, []);

  return (
    <div className="gallery-container">

      {/* ================= HEADER ================= */}
      <div className="gallery-header">
        <h1>Temple Idols</h1>

        <p>
          Divine forms that embody blessings, protection, and spiritual energy.
          Worshipping these sacred idols is believed to bring peace, prosperity,
          and removal of obstacles, filling devotees’ lives with divine grace
          and positivity.
        </p>
      </div>

      {/* ================= GRID ================= */}
      <div className="gallery-grid">
        {idols.map((idol) => (
          <div
            className="gallery-card"
            key={idol._id}
            onClick={() =>
              setSelectedImage(
                `${API_ENDPOINTS.BASE_URL}${idol.image}`
              )
            }
          >
            <img
              src={
                idol.image
                  ? (idol.image.startsWith("http") || idol.image.startsWith("data:")
                      ? idol.image
                      : `${API_ENDPOINTS.BASE_URL}${idol.image.startsWith("/") ? "" : "/"}${idol.image}`)
                  : "/images/banner.jpg"
              }
              alt={idol.title}
              onError={(e) => {
                const baseName = idol.image?.split("-").pop() || idol.image?.split("/").pop();
                if (baseName && !e.target.src.includes(`/images/${baseName}`)) {
                  e.target.src = `/images/${baseName}`;
                } else {
                  e.target.src = "/images/banner.jpg";
                }
              }}
            />

            <div className="gallery-overlay">
              <h3>{idol.title}</h3>
            </div>
          </div>
        ))}
      </div>

      {/* ================= MODAL ================= */}
      {selectedImage && (
        <div
          onClick={() => setSelectedImage(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.92)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          <img
            src={selectedImage}
            alt="idol preview"
            style={{
              maxWidth: "90%",
              maxHeight: "80%",
              borderRadius: "10px",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Idols;